module.exports = __webpack_public_path__ + "img/jiadian.43842d81.png";